var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"myProfile"},[_c('van-nav-bar',{staticClass:"nav_bar",attrs:{"title":"我的资料","left-arrow":"","placeholder":""},on:{"click-left":_vm.onClickLeft}}),_c('Personal')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }